import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SearchSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='21' viewBox='0 0 18 21' fill='none'>
    <circle cx='8.72462' cy='8.04786' r='7.14942' stroke='#5E678C' strokeWidth='1.5' />
    <path
      d='M13.335 14.6162L17.1748 19.8516'
      stroke='#5E678C'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export const SearchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SearchSvg} {...props} />
);
